import React from "react"
import Button from "src/components/core/atoms/button"

import classnames from "classnames/bind"
import { container, main, visible, alert, success } from "./snackbar.module.css"
const cx = classnames.bind( { container, main, visible, alert, success } )

const Snackbar = ( { variant, message, ctx, header, visible } ) => {

  return (
    <aside className={ cx( 'container', { 'visible': visible } ) } >
      <section className={ cx( 'main', { alert, success }[ variant ] ) }>
        { header && (
          <header>
            <h1>{ header }</h1>
          </header>
        ) }
        { message && <p>{ message }</p> }
        { ctx && (
          <Button variant="solid" onClick={ ctx.action }>{ ctx.text }</Button>
        ) }
      </section>
    </aside>
  )
}

export default Snackbar
